<template>
  <!-- Create / Edit -->
  <v-dialog
    v-model="dialog"
    width="600"
    persistent
    scrollable
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-toolbar dense style="max-height: 48px" elevation="0">
        <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text style="height: auto" class="pa-3" id="print-report-extract">
        <div>
          <!-- Print Only -->
          <div class="caption d-print-block">
            <div class="d-none d-print-block">
              <div class="overline font-weight-bold">
                {{ $t("routesToCollect") }}
              </div>
              <div>
                {{ $t("consultedBy") }}:
                {{ $localStorage.getItem("user_data").nome_usuario }}
              </div>
              <div>
                {{ $t("login") }}:
                {{ $localStorage.getItem("user_data").login }}
              </div>
              <div>
                {{ $t("dayAndTimeOfPrinting") }}:
                {{ new Date().toLocaleString() }}
              </div>
            </div>
            <div>
              <div>
                {{ $t("collector") }}: {{ $route.query.name_collector }} | Id:
                {{ $route.params.id_collector }}
              </div>
            </div>
          </div>
          <!-- end/ Print Only -->
          <v-card>
            <div class="py-0">
              <v-row class="align-center">
                <v-col cols="'12">
                  <v-btn
                    small
                    class="white black--text d-print-none"
                    @click="$printReportExtract()"
                  >
                    <v-icon small left>mdi-printer</v-icon>
                    {{ $t("print") }}
                  </v-btn>
                </v-col>
              </v-row>
            </div>

            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>{{ $t("agent") }}</th>
                    <th>{{ $t("route") }}</th>
                    <th class="text-right">{{ $t("payCollect") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in routes" :key="item.id">
                    <td>{{ item.id_agente }}</td>
                    <td>{{ item.nome_agente }}</td>
                    <td>{{ item.nome_rota }}</td>
                    <td
                      :class="item.saldo < 0 ? 'red--text' : 'green--text'"
                      class="text-right"
                    >
                      {{ item.saldo }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <div v-show="progress" class="text-center pa-4">
              <v-progress-circular indeterminate></v-progress-circular>
            </div>
            <v-alert class="ma-4" v-show="alert" type="warning" dense outlined>
              {{ $t("noRouteToCollect") }}
            </v-alert>
          </v-card>
        </div>
        <!-- RESUME -->
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="4" md="4"></v-col>
          <v-col cols="12" xs="12" sm="8" md="8">
            <v-card elevation="0" class="pa-3">
              <div class="subtitle-1 pb-1">{{ $t("summary") }}</div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>{{ $t("payable") }}</td>
                      <td class="text-right red--text">{{ pay_agents }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t("toCollect") }}</td>
                      <td class="text-right green--text">
                        {{ receive_agents }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("total") }}</td>
                      <td
                        :class="total < 0 ? 'red--text' : 'green--text'"
                        class="text-right"
                      >
                        {{ total }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "administrator-users-collectors-routes-to-collect",
  data: () => ({
    id_collector: "",
    name_collector: "",
    routes: "",
    pay_agents: "",
    receive_agents: "",
    total: "",
    alert: false,
    progress: true,
  }),
  mounted() {
    this.id_collector = this.$route.params.id_collector;
    this.name_collector = this.$route.query.name_collector;
    this.routesToCollect();
  },
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    // Request Api
    async routesToCollect() {
      this.progress = true;
      this.alert = false;

      const body = {
        id_collector: this.id_collector,
      };
      const request = await this.$request.post(
        "administrator/collectors/routesToCollect",
        body
      );
      if (request.length != 0) {
        this.buildReport(request.dados);
      } else {
        this.routes = [];
        this.alert = true;
      }

      this.progress = false;
    },

    // Build Report
    buildReport(data) {
      // Population table
      this.routes = data;

      // Resume Sum
      const sum = {
        pay_agents: 0,
        receive_agents: 0,
      };

      data.forEach((item) => {
        if (item.saldo > 0) {
          sum.receive_agents += Number(item.saldo);
        }
        if (item.saldo < 0) {
          sum.pay_agents += Number(item.saldo);
        }
      });

      this.pay_agents = this.decimalAdjustment(sum.pay_agents);
      this.receive_agents = this.decimalAdjustment(sum.receive_agents);
      this.total = this.decimalAdjustment(sum.receive_agents + sum.pay_agents);
    },

    // Ajust decimal
    decimalAdjustment: function(num) {
      return -(Math.round(-num + "e+2") + "e-2");
    },

    // Close Dialog
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
  },
};
</script>
